import styles from "./mainScreenBackground.module.scss";

/** Hub: linear #3c3962 → #6d5f94 (--mainScreenBackground) */
export function MainScreenBackground() {
  return <div className={styles.root} aria-hidden />;
}
